import { NamedEntityPropertyType } from '../../../../common-modules/interfaces/NamedEntityPropertyType';

export enum QuestionnaireStatusEnum {
    NoAnswers = 0,
    InProgress = 1,
    Updated = 2,
    Completed = 3,
    AddingReviews = 4,
    AddingReviewsFailed = 5,
}

export const QuestionnaireStatusMapping: { [type in QuestionnaireStatusEnum]: { name: string } } = {
    [QuestionnaireStatusEnum.NoAnswers]: {
        name: $localize`No answers`,
    },
    [QuestionnaireStatusEnum.InProgress]: {
        name: $localize`In progress`,
    },
    [QuestionnaireStatusEnum.Updated]: {
        name: $localize`Updated`,
    },
    [QuestionnaireStatusEnum.Completed]: {
        name: $localize`Completed`,
    },
    [QuestionnaireStatusEnum.AddingReviews]: {
        name: $localize`Adding reviews`,
    },
    [QuestionnaireStatusEnum.AddingReviewsFailed]: {
        name: $localize`Adding reviews failed`,
    },
};

export class QuestionnaireStatus implements NamedEntityPropertyType {
    public getName(priority: QuestionnaireStatusEnum): string {
        return QuestionnaireStatusMapping[priority].name;
    }

    public getAllTypes(): QuestionnaireStatusEnum[] {
        return Object.keys(QuestionnaireStatusMapping) as any as QuestionnaireStatusEnum[];
    }
}
